import React from "react";

const YearSelect = ({ value, onChange, disabled = false }) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  return (
    <select
      className="form-control"
      value={value}
      onChange={onChange}
      disabled={disabled}
    >
      <option value="">Select Year</option>
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>   
  );
};

export default YearSelect;